export default "__VITE_ASSET__DAs820_3__"